import type { DeepRequired } from '../fixtures.types'

const mortgageCalculatedValues: DeepRequired<MortgageCalculatedValues> = {
  __typename: 'MortgageCalculatedValues',
  calculated_net_proc_fee: null,
  calculated_gross_proc_fee: null,
  calculated_club_proc_fees: null,
  cost_over_full_term_exc_fees: null,
  cost_over_full_term_inc_fees: null,
  cost_over_full_term_inc_fees_cashback: null,
  cost_over_initial_term_exc_fees: null,
  cost_over_initial_term_inc_fees: null,
  cost_over_initial_term_inc_fees_cashback: null,
  fees: null,
  fees_at_origination: null,
  interest_cost_of_added_fees_full_term: null,
  loan_total_fees_added_to_loan: null,
  loan_total_premiums_or_insurance_added_to_loan: null,
  monthly_payment: null,
  mortgage_origination_inc_added_fees: null,
  remaining_term_months: null,
  revert_monthly_payment: null,
  total_mortgage_fees: null,
  can_generate_esis: null,
}

export default mortgageCalculatedValues
